export function Gallery() {
  const prev = document.querySelector('.js-swiper-arrow-prev');
  const next = document.querySelector('.js-swiper-arrow-next');

  if (!(prev instanceof HTMLElement) || !(next instanceof HTMLElement)) return;

  prev.addEventListener('keydown', (event: KeyboardEvent) => {
    if (event.key === 'ArrowLeft') {
      prev.click();
    }
  });

  next.addEventListener('keydown', (event: KeyboardEvent) => {
    if (event.key === 'ArrowRight') {
      next.click();
    }
  });

  const observer = new MutationObserver(() => {
    const activeSlide = document.querySelector('.swiper-slide-active');
    const allImages = document.querySelectorAll('.js-gallery-image');

    allImages.forEach((img) => {
      if (!(img instanceof HTMLElement)) return;
      if (activeSlide && activeSlide.contains(img)) {
        img.tabIndex = 0;
      } else {
        img.tabIndex = -1;
      }
    });
  });

  const gallerySwiper = document.querySelector('.js-gallery-swiper');

  if (gallerySwiper) {
    observer.observe(gallerySwiper, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }
}
